import {UserB} from '../pages/ok-admin/user-b/user-b';

export class StorageUtils {

  public storeToken(token: string) {
    localStorage.setItem('token', token);
  }

  public getToken() {
    return localStorage.token
  }

  public setActivity(activity: string) {
    localStorage.setItem('activity', activity)
  }

  public getActivity() {
    return localStorage.activity
  }

  public setBillingAverage(billingAverage: string) {
    localStorage.setItem('billingAverage', billingAverage)
  }

  public getBillingAverage() {
    return localStorage.billingAverage
  }

  public setDocument(document: string) {
    localStorage.setItem('document', document)
  }

  public getDocument() {
    return localStorage.document
  }

  public setQtdFuncs(qtdFuncs: string) {
    localStorage.setItem('qtdFuncs', qtdFuncs)
  }

  public getQtdFuncs() {
    return localStorage.qtdFuncs
  }

  public idUser(idUser: string) {
    localStorage.setItem('idUser', idUser);
  }
  public setEmailUser(email: string) {
    localStorage.setItem('emailUser', email)
  }
  public getEmailUser() {
    return localStorage.emailUser
  }

  public getIdUser() {
    return localStorage.idUser
  }

  public nameUser(nameUser: string) {
    localStorage.setItem('nameUser', nameUser);
  }

  public getNameUser() {
    return localStorage.nameUser
  }

  public urlHome(urlHome: string) {
    localStorage.setItem('urlHome', urlHome);
  }

  public getUrlHome() {
    return localStorage.urlHome
  }

  public idCompany(idCompany: string) {
    localStorage.setItem('idCompany', idCompany);
  }

  public getIdCompany() {
    return localStorage.idCompany
  }
  public documentCompany(documentCompany: string) {
    localStorage.setItem('documentCompany', documentCompany);
  }

  public getDocumentCompany() {
    return localStorage.documentCompany
  }

  public roleId(roleId: string) {
    localStorage.setItem('roleId', roleId);
  }

  public getRoleId() {
    return localStorage.roleId
  }

  public urlImage(urlImage: string) {
    localStorage.setItem('urlImage', urlImage);
  }

  public getUrlImage() {
    return localStorage.urlImage
  }

  public storeAutoLogin(user: UserB) {
    if (user == null) {
      localStorage.setItem('autoLogin', null);
    } else {
      localStorage.setItem('autoLogin', JSON.stringify(user));
    }
  }

  public getAutoLogin(): UserB {
    if (localStorage.autoLogin == null) {
      return null;
    }
    return JSON.parse(localStorage.autoLogin);
  }

  public storeLoggedUser(loggedUser: UserB) {
    if (loggedUser == null) {
      localStorage.setItem('loggedUser', null);
    } else {
      localStorage.setItem('loggedUser', JSON.stringify(loggedUser));
    }
  }

  public getLoggedUser(): UserB {
    if (localStorage.loggedUser == null) {
      return null;
    }
    return JSON.parse(localStorage.loggedUser);
  }
}
